import React from 'react';
import { X, Command } from 'lucide-react';
type KeyboardShortcutsGuideProps = {
  isOpen: boolean;
  onClose: () => void;
};
export function KeyboardShortcutsGuide({
  isOpen,
  onClose
}: KeyboardShortcutsGuideProps) {
  if (!isOpen) return null;
  const shortcuts = [{
    keys: ['?'],
    description: 'Show keyboard shortcuts'
  }, {
    keys: ['Esc'],
    description: 'Close dialogs or exit viewer'
  }, {
    keys: ['←', '→'],
    description: 'Navigate storybook pages'
  }, {
    keys: ['Cmd', 'K'],
    description: 'Quick search (coming soon)'
  }, {
    keys: ['N'],
    description: 'New recording (coming soon)'
  }];
  return <div className="fixed inset-0 z-50 flex items-center justify-center" data-id="element-1194">
      <div className="absolute inset-0 bg-black/30 backdrop-blur-sm" onClick={onClose} data-id="element-1195" />

      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 p-6" data-id="element-1196">
        <button onClick={onClose} className="absolute top-4 right-4 p-1 text-gray-400 hover:text-gray-600" data-id="element-1197">
          <X className="w-5 h-5" data-id="element-1198" />
        </button>

        <div className="flex items-center gap-3 mb-6" data-id="element-1199">
          <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center" data-id="element-1200">
            <Command className="w-5 h-5 text-purple-600" data-id="element-1201" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-1202">
            Keyboard Shortcuts
          </h2>
        </div>

        <div className="space-y-3" data-id="element-1203">
          {shortcuts.map((shortcut, index) => <div key={index} className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0" data-id="element-1204">
              <span className="text-gray-700" data-id="element-1205">{shortcut.description}</span>
              <div className="flex items-center gap-1" data-id="element-1206">
                {shortcut.keys.map((key, keyIndex) => <span key={keyIndex} data-id="element-1207">
                    <kbd className="px-2 py-1 bg-gray-100 border border-gray-300 rounded text-sm font-mono" data-id="element-1208">
                      {key}
                    </kbd>
                    {keyIndex < shortcut.keys.length - 1 && <span className="mx-1 text-gray-400" data-id="element-1209">+</span>}
                  </span>)}
              </div>
            </div>)}
        </div>

        <div className="mt-6 p-4 bg-gray-50 rounded-xl" data-id="element-1210">
          <p className="text-sm text-gray-600" data-id="element-1211">
            Press{' '}
            <kbd className="px-2 py-0.5 bg-white border border-gray-300 rounded text-xs font-mono" data-id="element-1212">
              ?
            </kbd>{' '}
            anytime to view shortcuts
          </p>
        </div>
      </div>
    </div>;
}